import useEditorProps from '@hooks/useEditorProps';
import { useSelected } from 'slate-react';

function MergeTag({ attributes, children, element }) {
    const { mergeTagsLabels } = useEditorProps();
    const selected = useSelected();

    const { bold, italic, underline, strikethrough, code, ...styles } =
        element.children[0];

    let textDecoration = '';
    if (underline) textDecoration += ' underline';
    if (strikethrough) textDecoration += ' line-through';

    const style = {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        borderRadius: '4px',
        display: 'inline-block',
        boxShadow: selected ? '0 0 0 1px #7d89ad' : 'none',
        fontWeight: bold ? 'bold' : undefined,
        fontStyle: italic ? 'italic' : undefined,
        textDecoration: textDecoration.trim() || undefined,
        fontFamily: code ? 'monospace' : undefined,
        ...styles,
    };

    return (
        <span style={style} {...attributes} contentEditable={false}>
            {mergeTagsLabels?.[element.tag] || element.tag}
            {children}
        </span>
    );
}

const mergeTag = {
    EditorElement: props => {
        return <MergeTag {...props} />;
    },
    PreviewElement: ({ node, mergeTags }) => {
        const { bold, italic, underline, strikethrough, code, ...styles } =
            node.children[0];
        let textDecoration = '';
        if (underline) textDecoration += ' underline';
        if (strikethrough) textDecoration += ' line-through';

        const style = {
            fontWeight: bold ? 'bold' : undefined,
            fontStyle: italic ? 'italic' : undefined,
            textDecoration: textDecoration.trim(),
            fontFamily: code ? 'monospace' : undefined,
            ...styles,
        };

        const tagValue = mergeTags?.[node.tag];
        const tag = node.tag;
        const defaultValue = '';
        console.log(tag);
        return `{{#if ${tag}}}{{${tag}}}{{else}}${defaultValue}{{/if}}`;
        return `{{${node.tag}}}`;

        return <span style={style}>{tagValue}</span>;
    },
};

export default mergeTag;
